export default {
  getTaxPlansList: (state) => state.taxPlanList,
  getSelectTaxPlan: (state) => state.selectTaxPlan,
  getDataSources: (state) => state.dataSources,
}
